export default __webpack_public_path__ + "static/media/screenshot7.badddd64.jpg";